const __debug = true;

const api_domain = '';
const api_host = api_domain + '/api/';

const api_endpoints = {
  saveSoundPreferences: 'savesoundpreferences',
  userdata: 'userdata',
  account: 'account',
  stripe_session: 'stripe_session',
  update_subscription: 'update_subscription',
  renew_session: 'renew-session',
};

export {

  api_host,
  api_endpoints,

  __debug
}
